import { useState } from 'react';
import { LayoutDashboard, Boxes, ArrowLeftRight, BookOpen, FileSpreadsheet } from 'lucide-react';
import { DashboardInventario } from '@/components/inventario/DashboardInventario';
import { StockView } from '@/components/inventario/StockView';
import { MovimientosView } from '@/components/inventario/MovimientosView';
import { KardexView } from '@/components/inventario/KardexView';
import { ImportarExcelView } from '@/components/inventario/ImportarExcelView';

type Tab = 'dashboard' | 'stock' | 'movimientos' | 'kardex' | 'importar';

const tabs: { id: Tab; label: string; icon: typeof LayoutDashboard }[] = [
  { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { id: 'stock', label: 'Stock', icon: Boxes },
  { id: 'movimientos', label: 'Movimientos', icon: ArrowLeftRight },
  { id: 'kardex', label: 'Kardex', icon: BookOpen },
  { id: 'importar', label: 'Importar', icon: FileSpreadsheet },
];

export function Inventario() {
  const [tab, setTab] = useState<Tab>('dashboard');

  return (
    <div className="max-w-6xl mx-auto">
      <div className="mb-6">
        <h2 className="text-xl sm:text-2xl font-bold text-gray-900">Inventario</h2>
        <p className="text-sm text-gray-500 mt-1">Stock global, alertas y movimientos por almacén.</p>
      </div>

      <div className="border-b border-gray-200 mb-6 overflow-x-auto">
        <nav className="flex gap-1 min-w-max">
          {tabs.map((t) => {
            const Icon = t.icon;
            const active = tab === t.id;
            return (
              <button
                key={t.id}
                onClick={() => setTab(t.id)}
                className={`flex items-center gap-2 px-4 py-2.5 text-sm font-medium border-b-2 transition-colors ${
                  active
                    ? 'border-blue-600 text-blue-700'
                    : 'border-transparent text-gray-500 hover:text-gray-700'
                }`}
              >
                <Icon size={16} />
                {t.label}
              </button>
            );
          })}
        </nav>
      </div>

      {tab === 'dashboard' && <DashboardInventario />}
      {tab === 'stock' && <StockView />}
      {tab === 'movimientos' && <MovimientosView />}
      {tab === 'kardex' && <KardexView />}
      {tab === 'importar' && <ImportarExcelView />}
    </div>
  );
}
